import { render, staticRenderFns } from "./IntentPage.vue?vue&type=template&id=b0ff68e4"
import script from "./IntentPage.vue?vue&type=script&lang=js"
export * from "./IntentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports